import Vue from 'vue'
import Router from 'vue-router'
import main from "../components/index.vue";
import login from "@/components/login.vue"
import loginByWeChat from "@/components/loginByWeChat.vue"
import customerWeChatBind from "@/components/customerWeChatBind.vue"
import information from "@/components/informationDetail.vue"
import rechargePay from "@/components/rechargePay.vue"
import recallInfo from "@/components/recallInfo.vue"

// RouterTab 内置路由
import {
  RouterTabRoutes
} from 'vue-router-tab'

// 引入布局框架组件
import Frame from '@/components/main.vue'

// 异步加载页面组件
const importPage = view => () =>
  import( /* webpackChunkName: "p-[request]" */ `@/components/${view}.vue`)

Vue.use(Router)

/**
 * Note: 路由配置项
 *
 * hidden: true                   // 当设置 true 的时候该路由不会再侧边栏出现 如401，login等页面，或者如一些编辑页面/edit/1
 * alwaysShow: true               // 当你一个路由下面的 children 声明的路由大于1个时，自动会变成嵌套的模式--如组件页面
 *                                // 只有一个时，会将那个子路由当做根路由显示在侧边栏--如引导页面
 *                                // 若你想不管路由下面的 children 声明的个数都显示你的根路由
 *                                // 你可以设置 alwaysShow: true，这样它就会忽略之前定义的规则，一直显示根路由
 * redirect: noRedirect           // 当设置 noRedirect 的时候该路由在面包屑导航中不可被点击
 * name:'router-name'             // 设定路由的名字，一定要填写不然使用<keep-alive>时会出现各种问题
 * meta : {
    noCache: true                // 如果设置为true，则不会被 <keep-alive> 缓存(默认 false)
    title: 'title'               // 设置该路由在侧边栏和面包屑中展示的名字
    icon: 'svg-name'             // 设置该路由的图标，对应路径src/assets/icons/svg
    breadcrumb: false            // 如果设置为false，则不会在breadcrumb面包屑中显示
  }
 */

// 公共路由
var constantRoutes = [
  //#region -- 登录Login --
  {
    // 每一个链接都是一个对象
    path: "/login", // 链接路径
    name: "login", // 路由名称，
    component: login // 对应的组件模板
  },
  //#endregion

  //#region -- 微信扫码登录Login --
  {
    // 每一个链接都是一个对象
    path: "/loginByWeChat", // 链接路径
    name: "loginByWeChat", // 路由名称，
    component: loginByWeChat // 对应的组件模板
  },
  //#endregion

  //#region -- 顾客收费小程序绑定 --
  {
    // 每一个链接都是一个对象
    path: "/customerWeChatBind", // 链接路径
    name: "customerWeChatBind", // 路由名称，
    component: customerWeChatBind // 对应的组件模板
  },
  //#endregion  

  //#region -- 手机打印监听 --
  {
    // 每一个链接都是一个对象
    path: "/information/:id", // 链接路径
    name: "information", // 路由名称，
    component: information // 对应的组件模板
  },
  //#endregion    

  //#region -- 平台充值页面 --
  {
    // 每一个链接都是一个对象
    path: "/rechargePay", // 链接路径
    name: "rechargePay", // 路由名称，
    component: rechargePay // 对应的组件模板
  },
  //#endregion  

  //#region -- 车辆召回信息 --
  {
    // 每一个链接都是一个对象
    path: "/recallInfo", // 链接路径
    name: "recallInfo", // 路由名称，
    component: recallInfo // 对应的组件模板
  },
  //#endregion      

  //#region -- 修改密码 --
  {
    path: "/permission/modiPassword", // 链接路径
    name: "修改密码", // 路由名称，
    meta: {
      auth: true,
      code: "permission"
    },
    iconCls: "el-icon-user",
    component: main, // 对应的组件模板(父节点要在main下，这样修改密码页面才正常)
    index: 15,
    hidden: true,
    children: [{
      path: "/permission/modiPassword", // 链接路径
      name: "修改密码list", // 路由名称，
      meta: {
        title: "修改密码", // 路由名称，
        auth: true,
        code: "permission"
      },
      hidden: true,
      component: () => import("@/components/permission/user/modiPassword.vue") // 对应的组件模板
    }]
  },
  //#endregion


  //#region -- 绑定微信 --
  {
    path: "/permission/bindWeChat", // 链接路径
    name: "绑定微信", // 路由名称，
    meta: {
      auth: true,
      code: "permission"
    },
    iconCls: "el-icon-user",
    component: main, // 对应的组件模板(父节点要在main下，这样修改密码页面才正常)
    index: 16,
    hidden: true,
    children: [{
      path: "/permission/bindWeChat", // 链接路径
      name: "绑定微信list", // 路由名称，
      meta: {
        title: "绑定微信", // 路由名称，
        auth: true,
        code: "permission"
      },
      hidden: true,
      component: () => import("@/components/permission/user/bindWeChat.vue") // 对应的组件模板
    }]
  },
  //#endregion


  //#region -- 延长授权 --
  {
    path: "/permission/modiAuth", // 链接路径
    name: "授权", // 路由名称，
    meta: {
      auth: true,
      code: "permission"
    },
    iconCls: "el-icon-user",
    component: main, // 对应的组件模板(父节点要在main下，这样修改密码页面才正常)
    index: 17,
    hidden: true,
    children: [{
      path: "/permission/modiAuth", // 链接路径
      name: "授权延期", // 路由名称，
      meta: {
        title: "授权设置", // 路由名称，
        auth: true,
        code: "permission"
      },
      hidden: true,
      component: () => import("@/components/permission/user/auth.vue") // 对应的组件模板
    }]
  },
  //#endregion

  //#region -- 检测站到期/停用自助授权（独立页面，不加载主框架菜单） --
  {
    path: "/stationAuth", // 链接路径
    name: "stationAuth", // 路由名称
    meta: {
      auth: true
    },
    hidden: true,
    component: () => import("@/components/permission/user/auth.vue") // 对应的组件模板
  },
  //#endregion

  //#region 404
  {
    path: "*", // 覆盖所有未找到的路由路径，并指向404页，该路由一定要放到最后边！！！
    // name: "404", // 路由名称(404页面不要加name,会导致跳回登录页面)，
    component: () => import("@/components/validationFailedVue/404.vue")
  }
  //#endregion
]

export default new Router({
  mode: 'history', // 去掉url中的#
  scrollBehavior: () => ({
    y: 0
  }),
  routes: constantRoutes
})



// WEBPACK FOOTER //
// ./src/router/index.js